const SIGNIN_URL = 'https://bshong-n8n.ngrok.io/webhook/user_signin';
const SIGNUP_URL = 'https://bshong-n8n.ngrok.io/webhook/user_signup';
const USER_INFO_URL = 'https://bshong-n8n.ngrok.io/webhook/user_info';

export async function notifyLogin({ sub, email, name, project }) {
  const sessionKey = `auth_notified:${project}`;
  if (sessionStorage.getItem(sessionKey)) return;
  sessionStorage.setItem(sessionKey, '1');

  const registeredKey = `user_registered:${sub}`;
  const isNewUser = !localStorage.getItem(registeredKey);
  const url = isNewUser ? SIGNUP_URL : SIGNIN_URL;

  try {
    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': '69420',
      },
      body: JSON.stringify({
        sub,
        email,
        name,
        project,
        isNewUser,
        timestamp: new Date().toISOString(),
      }),
    });
    if (isNewUser) {
      localStorage.setItem(registeredKey, '1');
    }
  } catch {
    // silently ignore
  }
}

export async function fetchUserInfo({ sub, email, name, project }) {
  try {
    const res = await fetch(USER_INFO_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': '69420',
      },
      body: JSON.stringify({ sub, email, name, project }),
    });
    if (!res.ok) return {};
    const data = await res.json();
    const row = Array.isArray(data) ? data[0] : data;
    return { ...row, coinBalance: row?.coin ?? row?.coinBalance ?? 0 };
  } catch {
    return {};
  }
}
